import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../../api/marvarApi"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

export const useFetchInitCreditsApplies = ({ location, paramsURL }) => {

    const dispatch = useDispatch()

    const Helpers = useHelpers()

    console.log('useFetchInitCreditsApplies');


    const { user } = useSelector((state) => state.auth)
    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({ Helpers })

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [dataModal, setDataModal] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }

    const FormRequestGlobal = useForm(defaultData.defaultFormGlobal)
    const FormDeposit = useForm(defaultData.defaultFormDeposit)
    const FormCollateral = useForm(defaultData.defaultFormCollateral)

    const Forms = {
        FormRequestGlobal,
        FormDeposit,
        FormCollateral,
    }


    const defaultFetchParams = {
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData,
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms
    }

    const fetchAllCustomers = useFetchData.useFetchAllCustomers({ ...defaultFetchParams })
    const fetchAllQuotes = useFetchData.useFetchAllQuotes({ ...defaultFetchParams })
    const fetchAllCreditsApplication = useFetchData.useFetchAllCreditsApplications({ ...defaultFetchParams })
    const fetchInfoApplication = useFetchData.useFetchInfoApplication({ ...defaultFetchParams })
    const fetchAllFiles = useFetchData.useFetchAllFiles({ ...defaultFetchParams })
    const fetchAllCashRegisters = useFetchData.useFetchAllCashRegisters({ ...defaultFetchParams })
    const fetchAllBanks = useFetchData.useFetchAllBanks({ ...defaultFetchParams })
    const fetchAllDeposits = useFetchData.useFetchAllDeposits({ ...defaultFetchParams })
    const fetchInfoDeposit = useFetchData.useFetchInfoDeposit({ ...defaultFetchParams })
    const fetchAllCollateral = useFetchData.useFetchAllCollateral({ ...defaultFetchParams })
    const fetchInfoCollateral = useFetchData.useFetchInfoCollateral({ ...defaultFetchParams })
    const fetchInfoObservations = useFetchData.useFetchInfoObservations({ ...defaultFetchParams })
    const fetchCollateralImages = useFetchData.useFetchCollateralImages({ ...defaultFetchParams });
    const fetchAllOrigins = useFetchData.useFetchAllOrigins({ ...defaultFetchParams })

    //Sin revisar
    const fetchAllVehicles = useFetchData.useFetchAllVehicles({ ...defaultFetchParams })
    const fetchInfoQuote = useFetchData.useFetchInfoQuote({ ...defaultFetchParams })

    const FetchData = {
        //Solicitudes
        fetchAllCreditsApplication,
        fetchInfoApplication,
        fetchAllOrigins,

        //Logs
        fetchInfoObservations,

        //Clientes
        fetchAllCustomers,

        //Garantias
        fetchAllCollateral,
        fetchInfoCollateral,
        fetchCollateralImages,

        //Depositos
        fetchAllCashRegisters,
        fetchAllBanks,
        fetchAllDeposits,
        fetchInfoDeposit,

        //Documentos
        fetchAllFiles,

        //Cotiazaciones
        fetchAllQuotes,

        // fetchInfoQuote,
    }

    const Actions = useActions({
        marvarApi, toggle, Helpers, user,
        FetchData,
        globalStates,
        defaultData,
        Forms,
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}